class ProjectFilterParams {
  constructor({
    SocietyTypeIds = null,

    projectStatusIds = null,

    cityIds = null,
    devIds = null,
       localityIds = null,
    areaIds = null,
    societyIds = null,

    societyAmenities = null,

    featured = null,
     status =null,

      budgetFrom= null,
    budgetTo= null,
    CarpetAreaFrom= null,
    CarpetAreaTo= null,


  } = {}) {
    this.SocietyTypeIds = SocietyTypeIds;
    this.projectStatusIds = projectStatusIds;

    this.cityIds = cityIds;
    this.devIds = devIds;
    this.localityIds = localityIds;
    this.areaIds = areaIds;
    this.societyIds = societyIds;

    this.societyAmenities = societyAmenities;

    this.featured = featured;
    this.status = status;

    this.budgetFrom = budgetFrom;
    this.budgetTo = budgetTo;
    this.CarpetAreaFrom = CarpetAreaFrom;
    this.CarpetAreaTo = CarpetAreaTo;
  }
}

export default ProjectFilterParams;
